/* eslint-disable react/jsx-no-bind */
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import EditIcon from '@mui/icons-material/Edit';
import HouseIcon from '@mui/icons-material/House';

import { Grid2, Tooltip } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import GlobalContext from '../../../../context/GlobalContext';
import {
  ActionAreaStyled,
  ConstructionNameStyled,
  // ContentStyled,
  MediaDivStyled,
  MediaStyled,
  StatusStyled,
} from './ConstructionCard.styles';

export function ConstructionCard(props) {
  const { id, status, name, facade, goToConstructionDetails, isClientPage } =
    props;

  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);

  const baseURL = process.env.REACT_APP_API;
  const protocol = subdomain.endsWith('-st') ? 'http' : 'https';

  const navigate = useNavigate();

  const matches1920 = useMediaQuery('(min-width:1920px)');
  const matches1280 = useMediaQuery('(min-width:1280px)');
  const matches1024 = useMediaQuery('(min-width:1024px)');
  const matches768 = useMediaQuery('(min-width:768px)');

  let size;
  if (matches1920) {
    size = 2;
  } else if (matches1280) {
    size = 3;
  } else if (matches1024) {
    size = 4;
  } else if (matches768) {
    size = 6;
  } else {
    size = 12;
  }

  function startEditing() {
    navigate(`/new-construction/${id}`);
  }

  return (
    <Grid2 item size={size} id="construction-card">
      <Card>
        <ActionAreaStyled onClick={() => goToConstructionDetails(id)}>
          {!facade ? (
            <MediaDivStyled>
              <HouseIcon color="inherit" style={{ fontSize: '8em' }} />
            </MediaDivStyled>
          ) : (
            <MediaStyled
              image={`${protocol}://${subdomain}.${baseURL}${facade}`}
              title={`Fachada da obra ${name}`}
              style={{ filter: status === 'Encerrada' && 'grayscale(100%)' }}
            />
          )}
          {status !== 'Em andamento' && (
            <StatusStyled style={{ backgroundColor: '#D2D2D2' }}>
              {status}
            </StatusStyled>
          )}
        </ActionAreaStyled>
        <Grid2 item>
          <Grid2 container spacing={2}>
            <Grid2 item size={isClientPage ? 12 : 9}>
              <CardContent>
                <Tooltip title={name}>
                  <ConstructionNameStyled>{name}</ConstructionNameStyled>
                </Tooltip>
              </CardContent>
            </Grid2>
            {!isClientPage && (
              <Grid2 item size={2}>
                <CardActions>
                  <IconButton onClick={startEditing} size="large">
                    <EditIcon fontSize="small" />
                  </IconButton>
                </CardActions>
              </Grid2>
            )}
          </Grid2>
        </Grid2>
      </Card>
    </Grid2>
  );
}

ConstructionCard.propTypes = {
  id: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  facade: PropTypes.string,
  goToConstructionDetails: PropTypes.func.isRequired,
  isClientPage: PropTypes.bool,
};

ConstructionCard.defaultProps = {
  isClientPage: false,
  facade: undefined,
};
